import React, { useEffect, useState } from "react";
import { TbGalaxy } from "react-icons/tb";
import { useLanguage } from "../Translations/LenguageContext";

const Logo = () => {
  const { t } = useLanguage();
  const [startAnimation, setStartAnimation] = useState(false);
  const [stopRotation, setStopRotation] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setStartAnimation(true);
    }, 1000); // initial delay

    return () => clearTimeout(timer);
  }, []);

  // Stop rotation after slide animation (fade + slide duration)
  useEffect(() => {
    if (startAnimation) {
      const rotationTimer = setTimeout(() => {
        setStopRotation(false);
      }, 10000); // fadeIn 1s + slide 2s
      return () => clearTimeout(rotationTimer);
    }
  }, [startAnimation]);

  // Fade out everything after 5s of being fully visible
  useEffect(() => {
      const fadeOutTimer = setTimeout(() => {
        setFadeOut(true);
      }, 5000); // 5s after fully visible
      return () => clearTimeout(fadeOutTimer);
    
  }, []);

  return (
    <div className={`logo_page_cont ${fadeOut ? "fade_out" : ""}`}>
      <div className={`logo_wrapper ${startAnimation ? "animate" : ""}`}>
        <TbGalaxy
          className={`galaxy_icon ${stopRotation ? "stop_rotate" : ""}`}
        />
        <span className="logo_text">Erioon</span>
      </div>
    </div>
  );
};

export default Logo;
